<template>
  <v-card
    :style="{
      background: value.sectionColor.backGround,
      color: value.sectionColor.text,
    }"
    class="pa-4 rounded-0"
    flat
  >
    <v-card-title class="section-title pa-2" style="color: inherit !important">
      {{ value.title }}
    </v-card-title>
    <v-card-subtitle class="ma-0 pa-2" style="color: inherit !important">
      {{ value.description }}
    </v-card-subtitle>

    <v-row v-if="items.length > 0" no-gutters>
      <v-col cols="12">
        <v-stepper v-if="showFeedback" v-model="e1" class="transparent" flat>
          <v-card
            class="rounded-lg px-2"
            color="rgba(255, 255, 255, .25"
            outlined
          >
            <v-stepper-header
              class="flex-nowrap overflow-x-auto custom-scrollbar elevation-0"
            >
              <template v-for="i in items.length">
                <v-stepper-step
                  :id="`step-${i}`"
                  :key="`${i}-step`"
                  :complete="e1 > i"
                  :step="i"
                  class="py-2 px-8"
                >
                  <span class="text-no-wrap">سوال {{ i }}</span>
                </v-stepper-step>

                <v-divider v-if="i !== items.length" :key="i" />
              </template>
            </v-stepper-header>
          </v-card>

          <v-stepper-items>
            <v-stepper-content
              v-for="n in items.length"
              :key="`${n}-content`"
              :step="n"
              class="pt-0 px-0"
            >
              <v-divider />

              <v-card class="mb-12 pa-2 transparent" flat>
                <pre v-html="items[n - 1].question" />
                <feedback-type
                  v-model="items[n - 1].value"
                  :type="items[n - 1].type"
                />

                <v-textarea
                  v-if="items[n - 1].description"
                  v-model="items[n - 1].answer"
                  :label="
                    items[n - 1].forceDesc
                      ? 'توضحیات (اجباری)'
                      : 'توضحیات (اختیاری)'
                  "
                  class="mt-4"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  messages="لطفا توضیحات مورد نظر خود را در این فیلد وارد نمایید (حداقل 3 کاراکتر)"
                  outlined
                  rows="3"
                />
              </v-card>

              <v-btn
                :disabled="n - 1 === 0"
                class="me-2"
                outlined
                @click="e1 = n - 1"
              >
                بازگشت
              </v-btn>

              <v-btn
                :disabled="isNextDisabled(n - 1)"
                color="primary"
                @click="nextStep(n)"
              >
                {{ n < items.length ? "ادامه" : "ثبت" }}
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import FeedbackType from "../cm/feedbackType";

export default {
  name: "bFeedbackView",

  components: { FeedbackType },

  props: {
    value: [Object, Array],
  },

  data: () => ({
    e1: 1,
    showFeedback: true,
    items: [],
    types: [
      { id: 1, type: "emoji" },
      { id: 2, type: "text" },
      { id: 3, type: "emoji_slider" },
      { id: 4, type: "star" },
      { id: 5, type: "thumbs" },
      { id: 6, type: "slider" },
    ],
  }),

  computed: {
    ...mapState("local", ["qr_id"]),
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  mounted() {
    this.getInformation();
  },

  methods: {
    nextStep(n) {
      // let stepEl = document.getElementById(`step-${n}`);
      // stepEl.scrollIntoView({behavior: "smooth", inline: "center"})

      if (n === this.items.length) {
        this.storeFeedback();
        this.e1 = 1;
        this.sendAwnser();
      } else {
        this.e1 = n + 1;
      }
    },
    storeFeedback() {
      this.showFeedback = false;
      this.$toast.success("بازخورد شما با موفقیت ثبت شد");
    },
    isNextDisabled(index) {
      const item = this.items[index];
      if (!item) return true;

      const valueIsInvalid = item.value === null || item.value === undefined;
      const descIsRequiredAndEmpty =
        item.description &&
        item.forceDesc &&
        (!item.answer || item.answer.trim().length < 3);

      return !!(valueIsInvalid || descIsRequiredAndEmpty);
    },

    getInformation() {
      this.$api
        .get(this.$qrApi + "/feedback", {
          params: { qr_id: this.qr_id },
        })
        .then(({ data }) => {
          this.items = data.data.map((item) => ({
            id: item.id,
            question: item.question,
            type: this.types.find((type) => type.id == item.type_id).type,
            answer: item.answer,
            description: item.has_description,
            forceDesc: item.description_status === "required",
            value: null,
          }));
        });
    },
    sendAwnser() {
      let arr = this.items.map((i) => {
        let obj = {
          question_id: i.id,
          type_id: this.types.find((t) => t.type == i.type).id,
          answer: i.awnser ?? "",
          rate: i.value,
        };
        return obj;
      });
      this.$api.post(this.$qrApi + "/feedback/answers ", arr).then(() => {
        console.log(data);
      });
    },
  },
};
</script>

<style scoped>
.section-title {
  position: relative;
}

.section-title:before {
  content: "";
  width: 150px;
  height: 1px;
  background: var(--v-primary-base);
  position: absolute;
  bottom: 0;
  right: 0;
}

pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
}
</style>
